import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Icons from "../../utils/components/icons";

const DeviceDetail = ({ closeDetail, deviceData, location }) => {
  const [tooltipText, setTooltipText] = useState("");
  const [clickStatus, setClickStatus] = useState({});
  const { t } = useTranslation("serviceTool");

  // Copy item function
  const copyToClipBoard = (targetedId) => {
    const elem = document.getElementById(targetedId);

    let TempDiv = document.createElement("div");
    TempDiv.innerHTML = elem.innerHTML
      .toString()
      .replaceAll(`mt-1"><span`, `mt-1">; &nbsp; <span`);

    let TempText = document.createElement("input");

    let space = "\u00A0";
    TempText.value = space + TempDiv.textContent;

    document.body.appendChild(TempText);
    TempText.select();

    document.execCommand("copy");
    document.body.removeChild(TempText);

    setClickStatus((prevStatus) => ({
      [targetedId]: !prevStatus[targetedId],
    }));

    setTooltipText(t("text_copied"));

    setTimeout(() => {
      setTooltipText("");
    }, 1000); // To Clear tooltip after 1 second
  };

  // Item render
  const infoItemRender = useCallback(
    (label, value) => {
      var itemId = label.replace(/ /g, "_");
      return (
        <div className={`detail-item item_${itemId}`}>
          <h4 className="text-9 mb-0 info-lable">
            {label} <span className="text-9">: </span>
          </h4>
          <div className="info-value">
            <span className="text-h1 value-span" id={itemId}>
              {value}
            </span>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip">{tooltipText}</Tooltip>}
              show={!!tooltipText}
            >
              <button
                className="copy-icon"
                onClick={() => copyToClipBoard(itemId)}
                id="copy"
              >
                <span>{Icons.copyIcon}</span>
              </button>
            </OverlayTrigger>
          </div>
        </div>
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tooltipText]
  );

  return (
    <div className="other-info-section" id="other-info-section">
      <div className="deviceTitleAndIcon" id="other_info">
        <p className="heading-h3 mb-0">{t("otherInformation")}</p>
        <div className="close-icon">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip">{tooltipText}</Tooltip>}
            show={clickStatus?.deviceOtherInfo !== undefined && !!tooltipText}
          >
            <button
              className="verticalBtn withoutText copyBtn"
              onClick={() => copyToClipBoard("deviceOtherInfo")}
              id="copy"
            >
              <span>{Icons.copyIcon}</span>
            </button>
          </OverlayTrigger>
          <button
            className="verticalBtn withoutText closeBtn"
            id="other_info_close"
            onClick={() => {
              closeDetail();
            }}
          >
            {Icons.closeIconWithCircle}
          </button>
        </div>
      </div>
      <div className="detail-section" id="deviceOtherInfo">
        {infoItemRender("Name", deviceData?.DeviceName || "-")}
        {infoItemRender("Location", location || "-")}
        {infoItemRender("UDI", deviceData?.UDI || "-")}
        {infoItemRender("Cartridge ID", deviceData?.CartridgeID || "-")}
        {infoItemRender("Sensor Panel ID", deviceData?.SensorPanelID || "-")}
        {infoItemRender("Sensor Board ID", deviceData?.sensorBoardId || "-")}
        {infoItemRender("STM ID", deviceData?.stmId || "-")}
        {infoItemRender("Comms Version", deviceData?.commsVersion || "-")}
        {infoItemRender(
          "Controller Version",
          deviceData?.controllerVersion || "-"
        )}
        {infoItemRender("Thing Name", deviceData?.DeviceUUID || "-")}
      </div>
    </div>
  );
};

export default DeviceDetail;
